import {NgModule, ENVIRONMENT_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './login/login.component';
import {NgChartsModule} from 'ng2-charts';
import {environment} from '../environments/environment';
import {getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService} from '@angular/fire/analytics';
import {AuthService} from "./auth.service";
import {FIREBASE_OPTIONS} from "@angular/fire/compat";
import {AuthGuard} from "@angular/fire/auth-guard";
import {AllCentersComponent} from "./components/dashboard/allcenters/all-centers.component";
import {HeaderComponent} from "./dashboard/header/header.component";
import {CreateEmployee} from "./components/employee/create-employee/create-employee";
import {SidenavComponent} from "./dashboard/sidenav/sidenav.component";
// Volunteers, Child, Centres, Reminders, Donors, UnitSponsorship components moved to lazy modules
import {EventsComponent} from "./components/events/events.component";
import {UnitsComponent} from "./components/units/units.component";
import {CaretakersComponent} from "./components/caretakers/caretakers.component";
import {DonationComponent} from "./components/Donationt/donation/donation.component";
// Centres components moved to centres.module.ts
import {DragDropDirective} from "./drag-drop.directive";
import {CommonModule, DatePipe, NgOptimizedImage, TitleCasePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {HttpClientModule} from "@angular/common/http";
// Child components moved to child-management.module.ts
import {ChildService} from "./components/child/child.service";
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {DonationtableComponent} from './components/Donationt/donationtable/donationtable.component';
// Child components moved to child-management.module.ts
import {RenderReceiptComponent} from './components/Donationt/render-receipt/render-receipt.component';
import {ViewDonationComponent} from './components/Donationt/view-donation/view-donation.component';
// Volunteers moved to volunteers-mgmt.module.ts
import {EmployeelistComponent} from './components/employee/employeelist/employeelist.component';
// Child components moved to child-management.module.ts
// Donor components moved to donors.module.ts
// Child components moved to child-management.module.ts
// Centres components moved to centres.module.ts
import {HospitalsComponent} from './modules/hospitals/components/hospitals.component';
import {AddHospitalComponent} from './modules/hospitals/components/add-hospital/add-hospital.component';
import {EditHospitalComponent} from './modules/hospitals/components/edit-hospital/edit-hospital.component';
// Child components moved to child-management.module.ts
import {ListCaretakerComponent} from './components/caretakers/list-caretaker/list-caretaker.component';
// Child components moved to child-management.module.ts
import {TypesComponent} from './components/types/types.component';
import {AddTypeComponent} from './components/types/add-type/add-type.component';
import {EditTypeComponent} from './components/types/edit-type/edit-type.component';
import {AddFieldComponent} from './components/types/add-field/add-field.component';
// Volunteers moved to volunteers-mgmt.module.ts
// Child components moved to child-management.module.ts
// Donors moved to donors.module.ts
import {initializeDialogService} from "../main";
import {CreateEventComponent} from './components/events/create-event/create-event.component';
// Reminders moved to reminders.module.ts
// Donors moved to donors.module.ts
// Child components moved to child-management.module.ts
import {SharedModule} from "./modules/shared/shared.module";
import {ViewEventComponent} from './components/events/view-event/view-event.component';
import {LogoutComponent} from './logout/logout.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import {MatCheckboxModule} from "@angular/material/checkbox";
// Centres moved to centres.module.ts
// Reminders moved to reminders.module.ts
import { MisComponent } from './components/dashboard/mis/mis.component';
import { FigurecardComponent } from './components/dashboard/figurecard/figurecard.component';
import { AgeBarComponent } from './components/dashboard/age-bar/age-bar.component';
import { HospitalsBarGraphComponent } from './components/dashboard/hospitals-bar-graph/hospitals-bar-graph.component';
import {PrettyJsonModule} from "angular2-prettyjson";
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { FinancialReportTableComponent } from './components/dashboard/financial-report-table/financial-report-table.component';
import { GeminiDemoComponent } from './components/gemini-demo/gemini-demo.component';
import { GeminiFirestoreExampleComponent } from './components/gemini-firestore-example/gemini-firestore-example.component';
import { YourdriveIntegrationComponent } from './components/yourdrive-integration/yourdrive-integration.component';
import { DbmsComponent } from './components/dbms/dbms.component';
// Gemini components moved to gemini.module.ts
// import { MealMateEventTableComponent } from './modules/meal-mate/meal-mate-event-table/meal-mate-event-table.component';
import { RazorpayDataComponent } from './components/razorpay-data/razorpay-data.component';
import { AddRazorpayDonationComponent } from './components/razorpay-data/add-razorpay-donation/add-razorpay-donation.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
// Child components moved to child-management.module.ts
import { DiagnosisComponent } from './components/dashboard/diagnosis/diagnosis.component';
import {SidebarComponent} from "./main/sidebar/sidebar.component";
import {NgScrollbarModule} from "ngx-scrollbar";
import { MainComponent } from './main/main.component';
import {FeatherModule} from "angular-feather";
import { Header2Component } from './main/header2/header2.component';
import {DirectionService} from "./services/direction.service";
import {RightSidebarService} from "./services/rightsidebar.service";
import {RightSidebarComponent} from "./main/right-sidebar/right-sidebar.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { HospitalAssessmentDialogComponent } from './modules/hospitals/components/hospital-assessment-dialog/hospital-assessment-dialog.component';
import { HospitalAssessmentComponent } from './modules/hospitals/components/hospital-assessment/hospital-assessment.component';
import { DisplayHospitalComponent } from './modules/hospitals/components/display-hospital/display-hospital.component';
import { RenameComponent } from './components/rename/rename.component';
import { RoleComponent } from './components/rename/role/role.component';
import { AddUserRoleComponent } from './components/rename/add-user-role/add-user-role.component';
import { EditUserRoleComponent } from './components/rename/edit-user-role/edit-user-role.component';
// Reminders moved to reminders.module.ts
import { ActivityLogComponent } from './components/activity-log/activity-log.component';
import { Mis2Component } from './components/dashboard/mis2/mis2.component';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

// Unit Sponsorship moved to unit-sponsorship.module.ts
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UnitTransferComponent } from './components/units/unit-transfer/unit-transfer.component';
import { GlossaryComponent } from './components/glossary/glossary.component';
import { RazorpayTransactionComponent } from './components/razorpay-transaction/razorpay-transaction.component';
import { EditEmployeeInfoComponent } from './components/employee/edit-employee-info/edit-employee-info.component';
import { AddGlossaryComponent } from './components/glossary/add-glossary/add-glossary.component';
import { EditGlossaryComponent } from './components/glossary/edit-glossary/edit-glossary.component';
// Reminders moved to reminders.module.ts
// Child moved to child-management.module.ts
import { ChangesComponent } from './components/activity-log/changes/changes.component';
import {MatRadioModule} from "@angular/material/radio";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatInputModule} from "@angular/material/input";
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
// Unit sponsorship moved to unit-sponsorship.module.ts
// Child moved to child-management.module.ts
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule} from "@angular/material/core";
import { AdmissionChartComponent } from './components/dashboard/admission-chart/admission-chart.component';
import { ApexHospitalChartComponent } from './components/dashboard/apex-hospital-chart/apex-hospital-chart.component';
import { ApexAgeChartComponent } from './components/dashboard/apex-age-chart/apex-age-chart.component';
import { CentresChartComponent } from './components/dashboard/centres-chart/centres-chart.component';
import { TotalUnitsChartComponent } from './components/dashboard/total-units-chart/total-units-chart.component';
import { UniqueAdmissionsChartComponent } from './components/dashboard/unique-admissions-chart/unique-admissions-chart.component';
import {FloorPlanComponent} from "./components/units/floor-plan/floor-plan.component";
import { CodeComponent } from './code/code.component';
import { QuarterReportComponent } from './quarter-report/quarter-report.component';
// Child moved to child-management.module.ts
import { PhotoGalleryComponent } from './components/photo-gallery/photo-gallery.component';
// Unit sponsorship moved to unit-sponsorship.module.ts
import { CentreEfficiencyComponent } from './components/dashboard/centre-efficiency/centre-efficiency.component';
import { DataCorrectionComponent } from './components/data-correction/data-correction.component';
import { ManualDonationComponent } from './components/Donationt/manual-donation/manual-donation.component';
import { FailedDonationsComponent } from './components/Donationt/failed-donations/failed-donations.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import {NgxPrintModule} from "ngx-print";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {connectAuthEmulator, getAuth, provideAuth} from "@angular/fire/auth";
import {connectDatabaseEmulator, getDatabase, provideDatabase} from "@angular/fire/database";
import {connectFirestoreEmulator, enableMultiTabIndexedDbPersistence, getFirestore, provideFirestore} from "@angular/fire/firestore";
import { ManualAttemptedDonationRecieptComponent } from './components/Donationt/manual-attempted-donation-reciept/manual-attempted-donation-reciept.component';
import { ViewAttemptedDonationRecieptComponent } from './components/Donationt/view-attempted-donation-reciept/view-attempted-donation-reciept.component';

import { MisBorivaliComponent } from './components/dashboard/mis-borivali/mis-borivali.component';
import { EditRolePermissionsComponent } from './components/employee/edit-rol-permissions/edit-role-permissions.component';
import { AddRolePermissionsComponent } from './components/employee/add-role-permissions/add-role-permissions.component';
import {EducationModule} from "./modules/education/education.module";
// Donor moved to donors.module.ts
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {DialogModule} from "@angular/cdk/dialog";
import {A11yModule} from "@angular/cdk/a11y";
import { DialogWithInputComponent } from './confirm-dialog/dialog-with-input/dialog-with-input.component';
import { AddFunctionMenuDialogComponent } from './components/employee/add-function-menu-dialog/add-function-menu-dialog.component';
import {connectFunctionsEmulator, getFunctions, provideFunctions} from "@angular/fire/functions";
import { MatIconModule } from '@angular/material/icon';
import { ViewAlertsListComponent } from './components/view-alerts-list/view-alerts-list.component';
import { MisTransportComponent } from './components/dashboard/mis-transport/mis-transport.component';
import { NotificationViewComponent } from './components/notification-view/notification-view.component';
import { MisEducationComponent } from './components/dashboard/mis-education/mis-education.component';
import { MisCounsellingComponent } from './components/dashboard/mis-counselling/mis-counselling.component';
import { MisDonationComponent } from './components/dashboard/mis-donation/mis-donation.component';
import { MisOprationsComponent } from './components/dashboard/mis-oprations/mis-oprations.component';

import { WhatsAppComponent } from './whatsapp/whatsapp.component';
import {EventListDialogComponent} from "./components/events/event-list-dialog/event-list-dialog.component";
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import {AngularFireFunctions, AngularFireFunctionsModule, REGION} from "@angular/fire/compat/functions";
import { AccountComponent } from './components/account/account.component';
import {ComponentsModule} from "./modules/shared/components/components.module";
import {
  EducationSopComponent
} from "./modules/education/components/education-sop/education-sop/education-sop.component";
import {ReportsModule} from "./modules/reports/reports.module";
import {MatChipsModule} from "@angular/material/chips";
let persistenceRequested = false;

@NgModule({
  declarations: [
    // Core/App Components
    AppComponent,
    MainComponent,
    SidebarComponent,
    RightSidebarComponent,
    HeaderComponent,
    Header2Component,
    SidenavComponent,
    LogoutComponent,
    DialogWithInputComponent,
    AllCentersComponent,
    AccountComponent,
    // Dashboard & Analytics
    DashboardComponent,
    MisComponent,
    Mis2Component,
    MisBorivaliComponent,
    FigurecardComponent,
    AgeBarComponent,
    HospitalsBarGraphComponent,
    FinancialReportTableComponent,
    DiagnosisComponent,
    AdmissionChartComponent,
    ApexHospitalChartComponent,
    ApexAgeChartComponent,
    CentresChartComponent,
    TotalUnitsChartComponent,
    UniqueAdmissionsChartComponent,
    CentreEfficiencyComponent,

    // Authentication & User Management
    LoginComponent,
    ChangePasswordComponent,
    CreateEmployee,
    EmployeelistComponent,
    EditEmployeeInfoComponent,
    RoleComponent,
    AddUserRoleComponent,
    EditUserRoleComponent,
    EditRolePermissionsComponent,
    AddRolePermissionsComponent,
    AddFunctionMenuDialogComponent,

    // Child Management - MOVED TO LAZY MODULE
    // Components moved to child-management.module.ts

    // Centers & Caretakers - MOVED TO LAZY MODULE
    // Components moved to centres.module.ts
    ListCaretakerComponent,
    CaretakersComponent,
    FloorPlanComponent,

    // Volunteers - MOVED TO LAZY MODULE (volunteers-mgmt.module.ts)

    // Events
    EventsComponent,
    CreateEventComponent,
    ViewEventComponent,
    EventListDialogComponent,

    // Donation & Donor Management - PARTIALLY MOVED TO LAZY MODULE
    DonationComponent,
    DonationtableComponent,
    RenderReceiptComponent,
    ViewDonationComponent,
    // Donors moved to donors.module.ts
    ManualDonationComponent,
    FailedDonationsComponent,
    ManualAttemptedDonationRecieptComponent,
    ViewAttemptedDonationRecieptComponent,
    RazorpayDataComponent,
    AddRazorpayDonationComponent,
    RazorpayTransactionComponent,

    // Hospitals
    HospitalsComponent,
    AddHospitalComponent,
    EditHospitalComponent,
    DisplayHospitalComponent,
    HospitalAssessmentComponent,
    HospitalAssessmentDialogComponent,

    // Units & Sponsorship - MOVED TO LAZY MODULE (unit-sponsorship.module.ts)
    UnitsComponent,
    UnitTransferComponent,

    // Miscellaneous
    BulkUploadComponent,
    RenameComponent,
    ActivityLogComponent,
    ChangesComponent,
    DataCorrectionComponent,
    PhotoGalleryComponent,
    CodeComponent,
    QuarterReportComponent,
    AddGlossaryComponent,
    EditGlossaryComponent,
    GlossaryComponent,
    // Gemini components moved to gemini.module.ts

    // External Integration
    YourdriveIntegrationComponent,
    DbmsComponent,

    // Reminders - MOVED TO LAZY MODULE (reminders.module.ts)

    // Types & Fields
    TypesComponent,
    AddTypeComponent,
    EditTypeComponent,
    AddFieldComponent,

    // Misc
     ViewAlertsListComponent,
     WhatsAppComponent,
     MisTransportComponent,
     NotificationViewComponent,
     MisEducationComponent,
     MisCounsellingComponent,
     MisDonationComponent,
     MisOprationsComponent,
    EducationSopComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
        MatOptionModule,
        MatButtonModule,
        MatSnackBarModule,
        MatIconModule,
        MatRadioModule,
        MatExpansionModule,
        BrowserAnimationsModule,
        NgChartsModule,
        ReactiveFormsModule,
        FullCalendarModule,
        HttpClientModule,
        SharedModule,
        MatCheckboxModule,
        PrettyJsonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        NgScrollbarModule,
        MatSlideToggleModule,
        NgOptimizedImage,
        MatAutocompleteModule,
        MatTabsModule,
    DialogModule,
        A11yModule,
    NgxPrintModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideAnalytics(() => getAnalytics()),
    // provideAuth(() => getAuth()),
    // provideDatabase(() => getDatabase()),
    // provideFirestore(() => getFirestore()),
    // provideAnalytics(() => getAnalytics()),
    AngularFireFunctionsModule,
    // provideFunctions(() => getFunctions()),
    // { provide: USE_AUTH_EMULATOR, useValue: environment.useEmulators ? ['http://localhost', 9099] : undefined },
    // { provide: USE_DATABASE_EMULATOR, useValue: environment.useEmulators ? ['localhost', 9000] : undefined },
    // { provide: USE_FIRESTORE_EMULATOR, useValue: environment.useEmulators ? ['localhost', 8080] : undefined },
    // { provide: USE_FUNCTIONS_EMULATOR, useValue: environment.useEmulators ? ['localhost', 5001] : undefined },

    provideDatabase(() => {
      const db = getDatabase();
      // if (environment.useEmulators) {
      //   connectDatabaseEmulator(db, 'localhost', 9000);
      // }
      return db;
    }),
    provideFirestore(() => {
      const firestore = getFirestore()

      if (environment.useEmulators) connectFirestoreEmulator(firestore, 'localhost', 8080);

      // Persisted cache. The dashboards re-subscribe to the same large queries on every
      // visit; with a cache on disk a listener resumes from a stored token and is billed
      // only for documents that changed since the last sync. Multi-tab so a second tab
      // does not silently lose it. Failure is non-fatal — private windows, blocked site
      // data and unsupported browsers all land here, and reads simply go to the network.
      // The factory can run more than once (AngularFire re-invokes it); enabling persistence
      // after Firestore has started throws synchronously, so guard and wrap it.
      if (!persistenceRequested) {
        persistenceRequested = true;
        try {
          enableMultiTabIndexedDbPersistence(firestore).catch(err => {
            console.warn('Firestore persistence unavailable; reads will go to the network every time.',
              err?.code ?? err);
          });
        } catch (err: any) {
          console.warn('Firestore persistence unavailable; reads will go to the network every time.',
            err?.code ?? err);
        }
      }

      return (firestore);

    }),
    provideAuth(() => {
      const auth = getAuth();

      // if (!environment.useEmulators) connectAuthEmulator(auth, `http://localhost:9099`)

      return (auth);
    }),
    provideFunctions(() => {
      const functions = getFunctions(undefined, 'us-central1');
      if (environment.useEmulators) {
        connectFunctionsEmulator(functions, 'localhost', 5001);
      }
      return functions;
    }),
    provideMessaging(() => getMessaging()),

    EducationModule,
    ComponentsModule,
    ReportsModule,
    MatChipsModule,

    //   CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // }),
  ],
  exports: [
    SidenavComponent,
    MisCounsellingComponent,
  ],
    providers: [
      ScreenTrackingService, UserTrackingService, AuthService,
        {provide: FIREBASE_OPTIONS, useValue: environment.firebase}, AuthGuard, ChildService, DatePipe,TitleCasePipe,
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},   // To change date formats by dd/MM/yyyy format
        {
            provide: ENVIRONMENT_INITIALIZER,
            useFactory: initializeDialogService,
            deps: [MatDialog],
            multi: true
        },
      { provide: REGION, useValue: 'us-central1' } ,// or your deployed region

      DirectionService,
      RightSidebarService,
        // { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        // {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
      {
        provide: ENVIRONMENT_INITIALIZER,
        useFactory: (afs: AngularFirestore) => () => {
          if (environment.useEmulators) {
            afs.firestore.settings({
              host: 'localhost:8080',
              ssl: false
            });
          }
        },
        deps: [AngularFirestore],
        multi: true
      },

      // If using emulators, add this:
      // {
      //   provide: ENVIRONMENT_INITIALIZER,
      //   useFactory: (functions: AngularFireFunctions) => () => {
      //     if (environment.useEmulators) {
      //       functions.useFunctionsEmulator('http://localhost:5001');
      //     }
      //   },
      //   deps: [AngularFireFunctions],
      //   multi: true
      // }

      // {
      //   provide: ENVIRONMENT_INITIALIZER,
      //   useFactory: (db: AngularFireDatabase) => () => {
      //     if (environment.useEmulators) {
      //       db.database.useEmulator('localhost', 9000);
      //     }
      //   },
      //   deps: [AngularFireDatabase],
      //   multi: true
      // }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
